import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const ChevronLeftIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M15.5304 6.53039L10.0608 12.0001L15.5304 17.4697L14.4698 18.5304L7.93945 12.0001L14.4698 5.46973L15.5304 6.53039Z", fill: "currentColor" }));
//# sourceMappingURL=ChevronLeftIcon.js.map